import { api } from "../App";
import { GET_COMPETENCE, SET_ROOM_TYPES_LOAD } from "./types";
import { createNotification } from "../components/Notifications/Notifications";

export const getCompetence = () => async (dispatch) => {
  try {
    dispatch({ type: SET_ROOM_TYPES_LOAD, payload: true });
    const { data } = await api.get(`/competence`);
    dispatch({ type: GET_COMPETENCE, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ROOM_TYPES_LOAD, payload: false });
  }
};

export const createCompetence = (data) => async (dispatch) => {
  try {
    await api.post(`/competence`, data);
    await dispatch(getCompetence());
  } catch (error) {
    createNotification('error', 'Ошибка');
  }
};

export const updateCompetence = (data) => async (dispatch) => {
  try {
    await api.put(`/competence/${data.id}`, data);
    await dispatch(getCompetence());
  } catch (ERR) {
  }
};

export const deleteCompetence = (competenceId) => async (dispatch) => {
  try {
    await api.delete(`/competence/${competenceId}`);
    createNotification('success', 'Успешно');
    await dispatch(getCompetence());
  } catch (ERR) {
  }
};
